import {Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, ViewEncapsulation, Input} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {FormControl} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {Globals} from '@app/services/globals.service';


@Component({
    selector: 'app-choose-tags',
    templateUrl: './choose-tags.component.html',
    styleUrls: ['./choose-tags.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ChooseTagsComponent implements OnInit {
    @Input() style: string;
    @Input() data: string[];

    @Output() outputToParent = new EventEmitter<any[]>();

    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    constructor(public taskService: TaskService,
                public  globalsService: Globals) {

    }

    visible = true;
    selectable = true;
    removable = true;

    separatorKeysCodes: number[] = [ENTER, COMMA];
    tagCtrl = new FormControl();

    userTags = [];
    tagsList: string[] = [];


    ngOnInit(): void {
        this.tagsList = this.globalsService.allTags;

        if (this.data.length > 0) {
            this.userTags = this.data;
        }
    }

    remove(tag: string): void {
        const index = this.userTags.indexOf(tag);
        if (index >= 0) {
            this.userTags.splice(index, 1);
        }
        this.outputToParent.emit(this.userTags);

    }

    selected(event: MatAutocompleteSelectedEvent): void {
        this.tagInput.nativeElement.value = '';
        if (this.userTags.includes(event.option.value)) return;
        this.userTags.push(event.option.value);
        this.outputToParent.emit(this.userTags);
    }


    add(event: MatChipInputEvent): void {
        const value = event.value;
        if (this.userTags.includes(value)) return;
        this.userTags.push(value);
        this.outputToParent.emit(this.userTags);
        this.tagInput.nativeElement.value = '';
    }
}

